import Link from 'next/link';

import { Breadcrumbs, Typography } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const LinkStyled = styled(Link)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',

  ...theme.animations.scaleText,
}));

const Breadcrumb = ({ listBreadcrumbChildren }) => {
  const theme = useTheme();

  const breadcrumbs = [
    <LinkStyled key="0" href="/" passHref>
      <a>Trang chủ</a>
    </LinkStyled>,
    ...listBreadcrumbChildren.map((children, index) => {
      return index + 1 < listBreadcrumbChildren.length ? (
        <LinkStyled key={index + 1} href={children.href}>
          <a>{children.name}</a>
        </LinkStyled>
      ) : (
        <Typography
          key={index + 1}
          fontWeight="bold"
          sx={{
            backgroundImage: theme.background.linearGradient,
            backgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          {children.name}
        </Typography>
      );
    }),
  ];

  return (
    <Breadcrumbs
      color="primary"
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb"
      sx={{ margin: '0 0 24px 24px' }}
    >
      {breadcrumbs}
    </Breadcrumbs>
  );
};

export default Breadcrumb;
